import { CATEGORIES, OFFER_TYPES } from './constants';

export const getOfferIcon = type => {
  switch (type) {
    case OFFER_TYPES.ACCEPTED:
      return 'thumbs-up';
    case OFFER_TYPES.DECLINED:
      return 'thumbs-down';
    case OFFER_TYPES.SENT:
      return 'send';
    default:
      return 'status';
  }
};

export const getCategoryIcon = (category, type) => {
  switch (category) {
    case CATEGORIES.ASSIGNMENT:
      return 'user';
    case CATEGORIES.COMMENT:
      return 'comment';
    case CATEGORIES.ISSUE:
      return 'maintenance';
    case CATEGORIES.OFFER:
      return getOfferIcon(type);
    case CATEGORIES.PUSH:
      return 'push';
    case CATEGORIES.SCHEDULE:
      return 'schedule';
    case CATEGORIES.IMPORT:
      return 'import';
    default:
      return 'status';
  }
};
